'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useRadioController } from '../../../../hooks/form-controllers';
import { useFormContext } from 'react-hook-form';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { AssociatedDealerSearchResult } from '../associated-dealer-search-result';
export const AssociatedDealerSearchResultList = ({ name, dealerCustomerStores, disabled }) => {
    const { control } = useFormContext();
    const { radioFieldset } = useRadioController({ control, name });
    return (_jsx(CatFieldset, { ...radioFieldset, children: dealerCustomerStores?.map((store, index) => {
            const isFirstValue = index === 0;
            const isLastValue = index === dealerCustomerStores.length - 1;
            return (_jsx(AssociatedDealerSearchResult, { name: name, store: store, isFirstValue: isFirstValue, isLastValue: isLastValue, disabled: disabled }, store.customerNumber));
        }) }));
};
